import { Link } from "@tanstack/react-router";
import gazelleAsset from "@/assets/gazelle-2017.webp.asset.json";
import aaaAsset from "@/assets/kreditvaerdighed-aaa.webp.asset.json";
import teknisAsset from "@/assets/teknis.webp.asset.json";
import logoAsset from "@/assets/elektriker-logo.webp.asset.json";

const services = [
  { to: "/ydelser", label: "Alle ydelser" },
  { to: "/ladestandere", label: "Ladestandere" },
  { to: "/varmepumper", label: "Varmepumper" },
  { to: "/energioptimering", label: "Energioptimering" },
  { to: "/groen-energi", label: "Grøn energi" },
  { to: "/fejlfinding", label: "Fejlfinding" },
];

const areas = [
  { to: "/elektriker-koebenhavn", label: "København" },
  { to: "/elektriker-frederiksberg", label: "Frederiksberg" },
  { to: "/elektriker-oesterbro", label: "Østerbro" },
  { to: "/elektriker-norrebro", label: "Nørrebro" },
  { to: "/elektriker-hellerup", label: "Hellerup" },
  { to: "/elektriker-charlottenlund", label: "Charlottenlund" },
  { to: "/elektriker-gladsaxe", label: "Gladsaxe" },
  { to: "/elektriker-nordsjaelland", label: "Nordsjælland" },
];

export function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-[var(--ink)] text-white/85">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div>
          <div className="flex items-center gap-2">
            <img
              src={logoAsset.url}
              alt="Elektriker-Elektriker logo"
              width={180}
              height={36}
              className="h-9 w-auto brightness-0 invert"
              loading="lazy"
            />
          </div>
          <p className="mt-4 text-sm leading-relaxed text-white/70">
            Autoriseret elektriker i København og omegn. Hurtig udrykning, faste priser og højeste
            kvalitet, privat og erhverv.
          </p>
          <p className="mt-4 text-sm text-white/70">CVR: 35209468</p>
          <div className="mt-6 flex flex-wrap items-stretch gap-3">
            <div className="flex flex-1 min-w-[120px] flex-col items-center justify-between gap-2 rounded-xl bg-white/5 p-3 ring-1 ring-white/10">
              <span className="text-center text-[10px] font-semibold uppercase tracking-wider text-white/80">
                Gazelle 2017
              </span>
              <img
                src={gazelleAsset.url}
                alt="Børsen Gazelle 2017, Elektriker-Elektriker er kåret som gazellevirksomhed"
                loading="lazy"
                width={185}
                height={70}
                className="h-9 w-auto object-contain brightness-0 invert"
              />
            </div>
            <div className="flex flex-1 min-w-[120px] flex-col items-center justify-between gap-2 rounded-xl bg-white p-3 ring-1 ring-white/10">
              <span className="text-center text-[10px] font-semibold uppercase tracking-wider text-[var(--ink)]">
                AAA kreditværdighed
              </span>
              <img
                src={aaaAsset.url}
                alt="AAA kreditværdighed, højeste rating for solid økonomi"
                loading="lazy"
                width={115}
                height={70}
                className="h-9 w-auto object-contain"
              />
            </div>
            <Link to="/tekniq-garanti" className="flex flex-1 min-w-[120px] flex-col items-center justify-between gap-2 rounded-xl bg-white p-3 ring-1 ring-white/10 transition hover:ring-primary/50">
              <span className="text-center text-[10px] font-semibold uppercase tracking-wider text-[var(--ink)]">
                TEKNIQ Garanti
              </span>
              <img
                src={teknisAsset.url}
                alt="Medlem af TEKNIQ, TEKNIQ Garanti"
                loading="lazy"
                width={304}
                height={70}
                className="h-9 w-auto object-contain"
              />
            </Link>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-white">Ydelser</h3>
          <ul className="mt-4 space-y-2 text-sm">
            {services.map((s) => (
              <li key={s.to}>
                <Link to={s.to} className="text-white/70 transition hover:text-white">
                  {s.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-white">Områder</h3>
          <ul className="mt-4 space-y-2 text-sm">
            {areas.map((a) => (
              <li key={a.to}>
                <Link to={a.to} className="text-white/70 transition hover:text-white">
                  {a.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/byer" className="text-white/70 transition hover:text-white">
                Se alle områder
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-white">Kontakt</h3>
          <ul className="mt-4 space-y-2 text-sm text-white/80">
            <li>Østersøgade 106A, 2100 København Ø</li>
            <li>
              <a href="tel:+4528700028" className="hover:text-white">
                +45 28 7000 28
              </a>
            </li>
            <li>
              <a href="mailto:el@elektriker-elektriker.dk" className="hover:text-white">
                el@elektriker-elektriker.dk
              </a>
            </li>
            <li className="pt-3">
              <Link
                to="/tilbud"
                className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-semibold text-primary-foreground hover:brightness-95"
              >
                Indhent tilbud
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-4 py-6 text-xs text-white/60 sm:flex-row sm:items-center sm:px-6 lg:px-8">
          <p>© {new Date().getFullYear()} Elektriker-Elektriker ApS. Alle rettigheder forbeholdes.</p>
          <div className="flex gap-5">
            <Link to="/careers" className="hover:text-white">Karriere</Link>
            <Link to="/sitemap" className="hover:text-white">Sitemap</Link>
            <Link to="/kontakt" className="hover:text-white">Kontakt</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
